import { render } from "./LegoOrderSteps.vue?vue&type=template&id=ff13b85e&scoped=true"
import script from "./LegoOrderSteps.vue?vue&type=script&lang=js"
export * from "./LegoOrderSteps.vue?vue&type=script&lang=js"

import "./LegoOrderSteps.vue?vue&type=style&index=0&id=ff13b85e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ff13b85e"

export default script